import { ACP } from '../constants.mjs';
import { getAccessControlUrlAll } from '../accessControl/getAccessControlUrlAll.mjs';
import { getPolicyUrls } from '../internal/getPolicyUrls.mjs';

//
/**
 * ```{note}
 * The ACP specification is a draft. As such, this function is experimental and
 * subject to change, even in a non-major release.
 * See also: https://solid.github.io/authorization-panel/acp-specification/
 * ```
 *
 * Get the URLs of policies applying to the given resource.
 *
 * @param resourceWithAcr The resource for which to retrieve URLs of policies
 * applying to it.
 * @returns Policy URL array.
 * @since 1.16.1
 */
function getPolicyUrlAll(resourceWithAcr) {
    return getPolicyUrls(resourceWithAcr, getAccessControlUrlAll(resourceWithAcr), ACP.apply);
}

export { getPolicyUrlAll };
